module.exports = __webpack_public_path__ + "img/20250421_CellSystems.908403ea.jpg";